<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'tryout/online/index' }">
                                Tryout
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            {{ tryout.name }}
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-4">
                <h3>Tryout Online</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row justify-content-end">
                            <div class="col">
                                &nbsp;
                            </div>
                            <div class="ml-auto col-auto" v-if="roleElligibleModified()">
                                <router-link v-bind:to="{ name: 'tryout/online/edit', params: {id: tryout.id} }" class="btn btn-link h4 p-0 my-0 mr-2">
                                    Edit
                                </router-link>
                                <button class="btn btn-link h4 p-0 m-0" type="button" v-on:click="modal.remove = true">
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <div class="card-title text-muted mb-0">
                                    Nama TO:
                                </div>
                                <p class="mb-2 text-loading">
                                    {{ tryout.name }}
                                </p>
                            </div>
                            <div class="col-12 col-sm-auto text-right" v-if="roleElligibleModified()">
                                <button class="btn btn-danger btn-sm mb-2" type="button" v-on:click="generatePasscode()">
                                    Generate Pass Code TO
                                </button>
                                <button class="btn btn-danger btn-sm mb-2" type="button" v-on:click="generatePassword({})">
                                    Generate Password Semua Kemampuan / Pelajaran
                                </button>
                            </div>
                        </div>
                        <div class="card-title text-muted mb-0">
                            Pass Code TO:
                        </div>
                        <p class="mb-2 font-weight-bold">
                            <i class="fa fa-unlock-alt mr-1"></i> {{ tryout.passcode || '-' }}
                        </p>
                        <div class="card-title text-muted mb-0">
                            TO Option:
                        </div>
                        <div class="mb-2">
                            <span class="mr-3" v-for="(label, option) in options">
                                <i class="fa fa-check mr-1 text-success" v-if="tryout[option]"></i>
                                <i class="fa fa-times mr-1 text-danger" v-else></i>
                                {{ label }}
                            </span>
                        </div>
                        <div class="card-title text-muted mb-0">
                            Kelas:
                        </div>
                        <p class="mb-2">
                            <ul class="mb-0 pl-3">
                                <li v-for="grade in tryout.grades" v-bind:key="grade.id" class="text-loading mb-1">{{ grade.name }}</li>
                            </ul>
                        </p>
                        <template v-if="tryout.tryoutOnline">
                            <div class="card-title text-muted mb-0">
                                Tanggal TO:
                            </div>
                            <p class="mb-2">
                                {{ [tryout.tryoutOnline.start, "YYYY-MM-DD HH:mm:ss"] | moment("D MMMM YYYY - HH.mm") }} 
                                s/d 
                                {{ [tryout.tryoutOnline.end, "YYYY-MM-DD HH:mm:ss"] | moment("D MMMM YYYY - HH.mm") }}
                            </p>
                        </template>
                        <template v-if="tryout.tryoutGroups.length">
                            <template v-for="tryoutGroup in tryout.tryoutGroups">
                                <div class="card-title mb-0 text-loading">
                                    <div class="row align-items-center mb-2">
                                        <template v-if="tryoutGroup.groupSubject">
                                            <div class="col text-muted">
                                                {{ tryoutGroup.groupSubject.name }}
                                                {{ tryoutGroup.code }}
                                                <template v-if="!tryout.isLocked">
                                                    <i class="fa fa-clock-o"></i> {{ $moment.duration(tryoutGroup.duration).asMinutes() }} menit
                                                </template>
                                            </div>
                                            <div class="col-auto font-weight-bold">
                                                <i class="fa fa-unlock-alt mr-1"></i> {{ tryoutGroup.passcode || '-' }}
                                            </div>
                                        </template>
                                        <template v-if="roleElligibleModified()">
                                            <div class="col-auto ml-auto align-self-center">
                                                <button type="button" class="btn btn-sm btn-danger mr-1" v-on:click="generatePassword({tryoutGroupID: tryoutGroup.id})">
                                                    Regenerate Password
                                                </button>
                                                <button type="button" class="btn btn-sm btn-danger px-4" v-on:click="form.attempt.filter.tryoutGroupID = tryoutGroup.id; modal.attempt = true">
                                                    Check Attempt
                                                </button>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <p class="mb-2">
                                    <ul class="mb-0 pl-3">
                                        <li v-for="tryoutSubject in tryoutGroup.tryoutSubjects" v-bind:key="tryoutSubject.id">
                                            <div class="row align-items-center mb-2">
                                                <div class="col">
                                                    <router-link v-bind:to="{name: 'tryout/online/question/view', params: {id: tryout.id, tryoutSubjectID: tryoutSubject.id}}" class="text-loading mb-2" v-if="tryoutSubject.subject">
                                                        {{ tryoutSubject.subject.name }} {{ tryoutSubject.code }}
                                                    </router-link>
                                                    - 
                                                    <span class="mr-2">{{ tryoutSubject.currentTotal }}/{{ tryoutSubject.totalQuestion }} Soal</span>
                                                    <template v-if="tryout.isLocked">
                                                        <i class="fa fa-clock-o"></i> {{ $moment.duration(tryoutSubject.duration).asMinutes() }} menit
                                                    </template>
                                                </div>
                                                <div class="col-auto ml-auto align-self-center">
                                                    <template v-if="roleElligibleModified()">
                                                        <button type="button" class="btn btn-sm btn-link font-weight-light btn-icon mr-1 my-1" v-on:click="download(tryoutSubject)" v-bind:disabled="!tryoutSubject.hasStudentAnswer">
                                                            <img src="/static/images/icon/download.svg" /> Download Jawaban
                                                        </button>
                                                        <span>
                                                            <input v-bind:id="'file-student-answer-' + tryoutSubject.id" type="file" class="form-control" v-on:change="uploadStudentAnswer($event, tryoutSubject)" placeholder="Choose File" accept=".xlsx, .xls, .csv"/>
                                                            <label v-bind:for="'file-student-answer-' + tryoutSubject.id" class="btn btn-sm btn-danger mr-1 my-1">
                                                                Upload Jawaban Siswa
                                                            </label>
                                                        </span>
                                                    </template>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </p>
                            </template>
                        </template>
                        <template v-else>
                            <div class="card-title text-muted mb-0">
                                Mata Pelajaran:
                            </div>
                            <p class="mb-2">
                                <ul class="mb-0 pl-3">
                                    <li v-for="tryoutSubject in tryout.tryoutSubjects" v-bind:key="tryoutSubject.id">
                                        <div class="row align-items-center">
                                            <div class="col">
                                                <router-link v-bind:to="{name: 'tryout/online/question/view', params: {id: tryout.id, tryoutSubjectID: tryoutSubject.id}}" class="text-loading mb-2">
                                                    {{ tryoutSubject.subject.name }} {{ tryoutSubject.code }}
                                                </router-link>
                                                - 
                                                <span class="mr-2">{{ tryoutSubject.currentTotal }}/{{ tryoutSubject.totalQuestion }} Soal</span>
                                                <i class="fa fa-clock-o"></i> {{ $moment.duration(tryoutSubject.duration).asMinutes() }} menit
                                            </div>
                                            <div class="col-auto font-weight-bold">
                                                <i class="fa fa-unlock-alt mr-1"></i> {{ tryoutSubject.passcode || '-' }}
                                            </div>
                                            <template v-if="roleElligibleModified()">
                                                <div class="col col-sm-auto ml-auto align-self-center mb-2">
                                                    <button type="button" class="btn btn-sm btn-link font-weight-light btn-icon mb-1" v-on:click="download(tryoutSubject)" v-bind:disabled="!tryoutSubject.hasStudentAnswer">
                                                        <img src="/static/images/icon/download.svg" /> Download Jawaban
                                                    </button>
                                                    <button type="button" class="btn btn-sm btn-danger mr-1 my-1" v-on:click="generatePassword({tryoutSubjectID: tryoutSubject.id})">
                                                        Regenerate Password
                                                    </button>
                                                    <button type="button" class="btn btn-sm btn-danger px-4 mr-1 my-1" v-on:click="form.attempt.filter.tryoutSubjectID = tryoutSubject.id; modal.attempt = true">
                                                        Check Attempt
                                                    </button>
                                                    <span>
                                                        <input v-bind:id="'file-student-answer-' + tryoutSubject.id" type="file" class="form-control" v-on:change="uploadStudentAnswer($event, tryoutSubject)" placeholder="Choose File" accept=".xlsx, .xls, .csv"/>
                                                        <label v-bind:for="'file-student-answer-' + tryoutSubject.id" class="btn btn-sm btn-danger mr-1 my-1">
                                                            Upload Jawaban Siswa
                                                        </label>
                                                    </span>
                                                </div>
                                            </template>
                                        </div>
                                    </li>
                                </ul>
                            </p>
                        </template>
                        <template v-if="roleElligibleModified()">
                            <hr />
                            <div class="card-title mb-0 text-right" >
                                <a v-bind:href="'/static/template/data-sample-tryout-student-answer.csv?timestamp=' + $moment(new Date).format('X')" class="mb-0 small">
                                    <i class="fa fa-download"></i> Template Jawaban Siswa
                                </a>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-4">
                        <template v-if="roleElligibleModified()">
                    <div class="row justify-content-sm-start justify-content-center mb-1">
                        <div class="col-auto">
                            <button class="btn btn-sm btn-outline-danger px-5" type="button" v-on:click="calculate()">
                                Kalkulasi Jawaban Siswa
                            </button>
                        </div>
                        <div class="col-auto pl-2">
                            <button class="btn btn-sm btn-outline-primary px-4" type="button" v-on:click="downloadCalculation()" v-bind:disabled="!calculated || !students.length">
                                Download Hasil Kalkulasi
                            </button>
                        </div>
                        <template v-if="tryout.tryoutGroups.length">
                            <div class="col-auto ml-sm-auto">
                                <button class="btn btn-sm btn-danger mr-1 px-5" type="button" v-on:click="modal.uploadGroupScore = true">
                                    Upload Nilai Siswa
                                </button>
                            </div>
                        </template>
                        <template v-else-if="calculated">
                            <div class="col-auto ml-sm-auto">
                                <button class="btn btn-sm btn-danger mr-1 px-5" type="button" v-on:click="modal.uploadSubjectScore = true">
                                    Upload Keterangan
                                </button>
                            </div>
                        </template>
                    </div>
                </template>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col">
                        <h3>Nilai Siswa</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mb-4">
                        <div id="table-primary" class="table-responsive" v-dragscroll="!isMobile()">
                            <table class="table">
                                <thead>
                                    <tr class="text-danger font-weight-bold">
                                        <th>
                                            Nama Lengkap
                                        </th>
                                        <th>
                                            Nomor Peserta BTA
                                        </th>
                                        <th v-for="tryoutSubject in tryoutSubjects" v-if="tryoutSubject.subject">
                                            <div>Nilai</div>
                                            {{ tryoutSubject.subject.name }}
                                        </th>
                                        <th>
                                            Total
                                        </th>
					<th>
                                            Lokasi BTA
                                        </th>
					<th>
                                            Asal Sekolah
                                        </th>
                                        <th >
                                            Peringkat
                                        </th>
                                        <th>
                                            Keterangan
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="shadow-sm" v-for="student in students" v-bind:key="student.userID">
                                        <td>
                                            <template v-if="student.user">
                                                <router-link v-bind:to="{name: 'student/view', params: {id: student.userID}}" class="text-loading" v-if="profile.isAdmin || (profile.isEmployee && (profile.employee.isDirector || profile.employee.isManager))">{{ student.user.name }}</router-link>
                                                <span class="text-loading" v-else>{{ student.user.name }}</span>
                                            </template>
                                        </td>
                                        <td>
                                            <span class="text-loading">{{ student.identity }}</span>
                                        </td>
                                        <td v-for="tryoutSubject in tryoutSubjects">
                                            <span class="text-loading">{{ score(student, tryoutSubject) }}</span>
                                        </td>
                                        <td>
                                            <span class="text-loading">{{ student.totalScore }}</span>
                                        </td>
					<td>
					    <template v-if="student.branch">
	                                            <span class="text-loading">{{ student.branch.name }}</span>
					    </template>
                                        </td>
					<td>
					    <template v-if="student.school">
	                                            <span class="text-loading">{{ student.school.name }}</span>
					    </template>
                                        </td>
                                        <td >
                                            <span class="text-loading">{{ student.rank }}</span>
                                        </td>
                                        <td class="text-left" v-html="note(student)">
                                            <span class="text-loading"></span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-12 mb-4">
                        <nav class="float-right">
                            <paginate v-model="page" next-text="<i class='fa fa-chevron-right'></i>" prev-text="<i class='fa fa-chevron-left'></i>" v-bind:click-handler="paginate" v-bind:page-count="pageCount" container-class="pagination pagination-sm flex-wrap" page-class="page-item" prev-class="page-item" v-bind:next-class="'page-item'" page-link-class="page-link" prev-link-class="page-link" next-link-class="page-link" v-bind:hide-prev-next="true">
                            </paginate>
                        </nav>
                    </div>
                </div>
            </div>
        </div>

        <b-modal v-if="roleElligibleModified()" v-model="modal.remove" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin mau menghapus Tryout Online ini? Karena jika sudah terhapus data tidak dapat dikembalikan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="remove">
                            Ya
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.remove = false">
                            Batal
                        </button>        
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal v-if="roleElligibleModified()" v-on:hide="form.attempt.filter.tryoutSubjectID = ''; attempts = []" size="lg" v-model="modal.attempt" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Clear Attempt
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="clearAttempt()">
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label class="font-weight-medium required w-100 text-muted">Periode TO</label>
                                <div class="row">
                                    <div class="col-lg col-12 mb-2">
                                        <div class="input-group input-group-sm">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </span>
                                            </div>
                                            <datetimepicker v-model="form.attempt.filter.start" v-bind:config="datetimepickerOptions.start" placeholder="Tanggal Mulai" class="form-control-sm" required></datetimepicker>
                                        </div>
                                    </div>
                                    <div class="col-lg-auto d-none d-lg-block px-0">
                                        <i class="fa fa-minus"></i>
                                    </div>
                                    <div class="col-lg col-12 mb-2">
                                        <div class="input-group input-group-sm">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </span>
                                            </div>
                                            <datetimepicker v-model="form.attempt.filter.end" v-bind:config="datetimepickerOptions.end" placeholder="Tanggal Selesai" class="form-control-sm" required></datetimepicker>
                                        </div>
                                    </div>
                                    <div class="col-auto ml-auto">
                                        <button type="button" class="btn btn-danger btn-sm px-3" v-on:click="checkAttempt()">
                                            <i class="fa fa-check"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4" v-if="attempts.length">
                        <div class="col">
                            <table class="table table-sm table-borderless">
                                <thead>
                                    <tr>
                                        <td class="text-danger font-weight-bold">
                                            NIP Siswa
                                        </td>
                                        <td class="text-danger font-weight-bold">
                                            Nama Siswa
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="attempt in attempts">
                                        <td>
                                            {{ attempt.student.identity }}
                                        </td>
                                        <td>
                                            {{ attempt.student.user.name }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col text-center">
                            <!--<button type="submit" class="btn btn-outline-danger btn-sm px-3" v-bind:disabled="!attempts.length">
                                Clear Attempt
                            </button>-->
                            <button class="btn btn-danger btn-sm px-5 ml-3" type="button" v-on:click="modal.attempt = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>

        <b-modal v-if="tryout.tryoutGroups.length && roleElligibleModified()" v-model="modal.uploadGroupScore" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Upload Nilai Siswa
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="uploadStudentGroupScore()">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="row mb-2 align-items-center">
                                <div class="col text-right">
                                    <a v-bind:href="'/static/template/data-sample-group-score.csv?timestamp=' + $moment(new Date).format('X')" class="mb-0 small">
                                        Download Template
                                    </a>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Jenis Penilaian</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <select v-model="form.uploadGroupScore.tryoutGroupID" class="form-control form-control-sm" required>
                                        <option disabled value="" selected>Pilih Jenis Penilaian...</option>
                                        <option v-for="tryoutGroup in tryout.tryoutGroups" v-bind:value="tryoutGroup.id" v-bind:key="tryoutGroup.id" v-if="tryoutGroup.groupSubject">{{ tryoutGroup.groupSubject.name }} {{ tryoutGroup.code }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Upload File</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <input id="file-student-group-score" type="file" class="form-control" v-on:change="fileStudentGroupScore($event)" placeholder="Choose File" accept=".xlsx, .xls, .csv" required/>
                                    <label for="file-student-group-score" class="form-control form-control-sm text-truncate">
                                        <button type="button" class="btn btn-danger font-weight-bold">
                                            Choose File
                                        </button> 
                                        {{ form.uploadGroupScore['group-score'].name }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                Submit
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-5 ml-3" type="button" v-on:click="modal.uploadGroupScore = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>

        <b-modal v-if="roleElligibleModified()" v-model="modal.uploadSubjectScore" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Upload Nilai Siswa
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="uploadStudentSubjectScore()">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="row mb-2 align-items-center">
                                <div class="col text-right">
                                    <a v-bind:href="'/static/template/data-sample-subject-score.csv?timestamp=' + $moment(new Date).format('X')" class="mb-0 small">
                                        Download Template
                                    </a>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Mata Pelajaran</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <select v-model="form.uploadSubjectScore.tryoutSubjectID" class="form-control form-control-sm" required>
                                        <option disabled value="" selected>Pilih Mata Pelajaran...</option>
                                        <option v-for="tryoutSubject in tryout.tryoutSubjects" v-bind:value="tryoutSubject.id" v-bind:key="tryoutSubject.id" v-if="tryoutSubject.subject">{{ tryoutSubject.subject.name }} {{ tryoutSubject.code }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Upload File</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <input id="file-student-subject-score" type="file" class="form-control" v-on:change="fileStudentSubjectScore($event)" placeholder="Choose File" accept=".xlsx, .xls, .csv" required/>
                                    <label for="file-student-subject-score" class="form-control form-control-sm text-truncate">
                                        <button type="button" class="btn btn-danger font-weight-bold">
                                            Choose File
                                        </button> 
                                        {{ form.uploadSubjectScore['subject-score'].name }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                Submit
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-5 ml-3" type="button" v-on:click="modal.uploadSubjectScore = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import { dragscroll } from 'vue-dragscroll';
    import Paginate from 'vuejs-paginate';
    import Datetimepicker from 'vue-bootstrap-datetimepicker';
    import qs from 'qs';

    /**
     * @param {Object} tryout
     */
    export default {
        name: "TryoutOnlineView",
        directives: {dragscroll},
        components: {
            Paginate,
            Datetimepicker
        },
        watch: {
            'form.attempt.filter.start'(start) {
                if (this.tryout.tryoutOnline) {
                    this.datetimepickerOptions.end.minDate = this.$moment(this.tryout.tryoutOnline.start, 'YYYY-MM-DD HH:mm:ss').startOf('date');
                }
                if (start) {
                    if (!this.form.attempt.filter.end || this.$moment(start, 'YYYY-MM-DD HH:mm:ss').isAfter(this.$moment(this.form.attempt.filter.end, 'YYYY-MM-DD HH:mm:ss'))) {
                        this.form.attempt.filter.end = start;
                    }
                    this.datetimepickerOptions.end.minDate = this.$moment(start, 'YYYY-MM-DD HH:mm:ss');
                } else {
                    this.form.attempt.filter.end = '';
                }
            },
            'form.attempt.filter.end'(end) {
                if (end) {
                    if (this.$moment(end, 'YYYY-MM-DD HH:mm:ss').isBefore(this.$moment(this.form.attempt.filter.start, 'YYYY-MM-DD HH:mm:ss'))) {
                        this.form.attempt.filter.start = end;
                    }
                }
            },
            tryout(tryout) {
                if (tryout.tryoutOnline) {
                    this.datetimepickerOptions.start.maxDate = this.$moment(tryout.tryoutOnline.end, 'YYYY-MM-DD HH:mm:ss').endOf('date');
                    this.datetimepickerOptions.end.maxDate = this.$moment(tryout.tryoutOnline.end, 'YYYY-MM-DD HH:mm:ss').endOf('date');
                }
            }
        },
        computed: mapState([
            'profile',
            'term'
        ]),
        data() {
            return {
                form: {
                    attempt: {
                        filter: {
                            start: '',
                            end: '',
                            tryoutSubjectID: '',
                            tryoutGroupID: ''
                        }
                    },
                    uploadGroupScore: {
                        tryoutGroupID: '',
                        'group-score': ''
                    },
                    uploadSubjectScore: {
                        tryoutGroupID: '',
                        'subject-score': ''
                    }
                },
                tryout: {tryoutGroups: [], grades: []},
                tryoutSubjects: [],
                students: [],
                attempts: [],
                datetimepickerOptions: {
                    start: {format: 'YYYY-MM-DD HH:mm:ss', useCurrent: 'day', locale: 'id', maxDate: false, showClear: true},
                    end: {format: 'YYYY-MM-DD HH:mm:ss', useCurrent: 'day', locale: 'id', maxDate: false, minDate: false, showClear: true}
                },
                options: {isLocked: 'Lock Option', hasSessionChecking: 'Session Checking', hasSubmit: 'Has Submit'},
                modal: {
                    remove: false,
                    attempt: false,
                    uploadGroupScore: false,
                    uploadSubjectScore: false
                },
                pageCount: 0,
                page: 1,
                calculated: false
            };
        },
        methods: {
            checkAttempt() {
                let url = '';
                if (this.tryout.tryoutGroups.length) {
                    url = process.env.API_URL + '/group-attempt';
                } else {
                    url = process.env.API_URL + '/subject-attempt';
                }
                this.axios.get(url, {params: this.form.attempt, paramsSerializer: (params) => qs.stringify(params, {encode: false})}).then(response => {
                    if (response.data.status) {
                        this.attempts = response.data.data;
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            clearAttempt() {
                let url = '';
                if (this.tryout.tryoutGroups.length) {
                    url = process.env.API_URL + '/group-attempt/deletes';
                } else {
                    url = process.env.API_URL + '/subject-attempt/deletes';
                }
                this.axios.post(url, this.form.attempt).then(response => {
                    if (response.data.status) {
                        this.modal.attempt = false;
                        this.$toastr('success', response.data.message, 'Success');
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            calculate() {
                this.axios.get(process.env.API_URL + '/tryout/calculate/' + this.tryout.id).then(response => {
                    if (response.data.status) {
                        this.paginate(1);
                        this.$toastr('success', response.data.message, 'Success');
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            downloadCalculation() {
                if (!this.students || !this.students.length) {
                    this.$toastr('warning', 'Tidak ada data untuk diunduh', 'Warning');
                    return;
                }
                const headers = ['Nama Lengkap', 'Nomor Peserta BTA'];
                const subjectHeaders = this.tryoutSubjects && this.tryoutSubjects.length ? this.tryoutSubjects.filter(ts => ts.subject).map(ts => ts.subject.name) : [];
                headers.push(...subjectHeaders);
                headers.push('Total', 'Lokasi BTA', 'Asal Sekolah', 'Peringkat', 'Keterangan');

                const escapeCsv = (v) => '"' + String(v === null || v === undefined ? '' : v).replace(/"/g, '""') + '"';

                const rows = this.students.map(student => {
                    const row = [];
                    row.push(student.user ? student.user.name : '');
                    row.push(student.identity || '');
                    (this.tryoutSubjects || []).forEach(ts => {
                        if (ts && ts.subject) {
                            row.push(this.score(student, ts));
                        }
                    });
                    row.push(student.totalScore || '');
                    row.push(student.branch ? student.branch.name : '');
                    row.push(student.school ? student.school.name : '');
                    row.push(student.rank || '');
                    const noteText = (this.note(student) || '').replace(/<br\s*\/?>(\s*)/g, ' | ');
                    row.push(noteText);
                    return row.map(escapeCsv).join(',');
                });

                const csvContent = [headers.map(escapeCsv).join(','), ...rows].join('\r\n');
                const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'});
                const filename = 'hasil-kalkulasi-tryout-' + (this.tryout.id || 'data') + '.csv';
                if (navigator.msSaveBlob) { // IE 10+
                    navigator.msSaveBlob(blob, filename);
                } else {
                    const link = document.createElement('a');
                    const url = URL.createObjectURL(blob);
                    link.setAttribute('href', url);
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    setTimeout(() => {
                        document.body.removeChild(link);
                        URL.revokeObjectURL(url);
                    }, 1000);
                }
            },
            generatePasscode() {
                this.axios.post(process.env.API_URL + '/tryout/passcode-tryout', {tryoutID: this.tryout.id}).then(response => {
                    if (response.data.status) {
                        this.fetchTryout();
                        this.$toastr('success', response.data.message, 'Success');
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            generatePassword(params) {
                let url = Object.keys(params).length ? '/tryout/passcode' : '/tryout/passcode-all';
                this.axios.post(process.env.API_URL + url, Object.assign({}, {tryoutID: this.tryout.id}, params)).then(response => {
                    if (response.data.status) {
                        this.fetchTryout();
                        this.$toastr('success', response.data.message, 'Success');
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            download(tryoutSubject) {
                let token = localStorage.getItem("vue-authenticate.vueauth_token");
                window.location = process.env.API_URL + '/tryout/download-student-answer?' + qs.stringify({tryoutSubjectID: tryoutSubject.id, token: token, termID: this.term.id}, {encode: false});
            },
            score(student, tryoutSubject) {
                var subjectScore = student.subjectScores.find(subjectScore => subjectScore.tryoutSubjectID === tryoutSubject.id);
                return subjectScore ? subjectScore.score : 0;
            },
            note(student) {
                let notes = [];
                if (this.tryout.tryoutGroups.length) {
                    notes = student.groupScores.map(groupScore => groupScore.note || '');
                } else {
                    notes = student.subjectScores.map(subjectScore => subjectScore.note || '');
                }
                return notes.join('<br />');
            },
            paginate(page, scroll = true) {
                this.axios.get(process.env.API_URL + '/tryout/scores/' + this.tryout.id, {params: {page: page}}).then(response => {
                    this.students = response.data.data.data;
                    this.pageCount = response.data.data.total ? response.data.data.last_page : 0;
                    this.calculated = response.data.data.total > 0;

                    if (scroll) {
                        document.getElementById('table-primary').scrollIntoView();
                        var headerElement = document.getElementsByTagName('nav');
                        if (headerElement.length) {
                            window.scrollBy(0, headerElement[0].offsetHeight * -1);
                        }
                    }
                });
            },
            remove() {
                this.axios.post(process.env.API_URL + '/tryout/delete/' + this.tryout.id).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'tryout/online/index'});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                    this.modal.remove = false;
                });
            },
            fetchTryout() {
                this.axios.get(process.env.API_URL + '/tryout/' + this.$route.params.id).then(response => {
                    this.tryout = response.data.data;
                    if (!this.tryout.tryoutOnline) {
                        this.$router.replace({name: 'error', params: {code: 404, message: 'Tryout online not found'}});
                    }
                    this.form.attempt.filter.start = this.tryout.tryoutOnline.start;
                    this.form.attempt.filter.end = this.tryout.tryoutOnline.end;

                    var tryoutGroups = this.tryout.tryoutGroups;
                    if (tryoutGroups.length) {
                        this.tryoutSubjects = [];
                        for (var i = 0; i < tryoutGroups.length; i++) {
                            this.tryoutSubjects.push(...tryoutGroups[i].tryoutSubjects);
                        }
                    } else {
                        this.tryoutSubjects = this.tryout.tryoutSubjects;
                    }
                    this.paginate(1, false);
                    document.title = 'Tryout Online ' + this.tryout.name + ' - ' + process.env.APP_NAME;
                }).catch((error) => {
                    this.$router.replace({name: 'error', params: {code: error.response.status, message: error.response.statusText}});
                });
            },
            uploadStudentGroupScore() {
                var formData = new FormData();
                for (var attribute in this.form.uploadGroupScore) {
                    formData.set(attribute, this.form.uploadGroupScore[attribute]);
                }
                this.axios.post(process.env.API_URL + '/tryout/upload-group-score', formData).then(response => {
                    if (response.data.status) {
                        this.modal.uploadGroupScore = false;
                        this.$toastr('success', response.data.message, 'Success');
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            uploadStudentSubjectScore() {
                var formData = new FormData();
                for (var attribute in this.form.uploadSubjectScore) {
                    formData.set(attribute, this.form.uploadSubjectScore[attribute]);
                }
                this.axios.post(process.env.API_URL + '/tryout/upload-subject-score', formData).then(response => {
                    if (response.data.status) {
                        this.paginate(1);
                        this.modal.uploadSubjectScore = false;
                        this.$toastr('success', response.data.message, 'Success');
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            uploadStudentAnswer(event, tryoutSubject) {
                var input = event.currentTarget;
                if (input.files && input.files[0]) {
                    var formData = new FormData();
                    formData.set('tryoutSubjectID', tryoutSubject.id);
                    formData.set('student-answer', input.files[0]);
                    this.axios.post(process.env.API_URL + '/question/upload-student-answer', formData).then(response => {
                        if (response.data.status) {
                            this.$toastr('success', response.data.message, 'Success');
                            this.fetchTryout();
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                    });
                } else {
                    this.$toastr('warning', 'Please select file', 'Warning');
                }
            },
            fileStudentGroupScore(event) {
                var input = event.currentTarget;
                if (input.files && input.files[0]) {
                    this.form.uploadGroupScore['group-score'] = input.files[0];
                }
            },
            fileStudentSubjectScore(event) {
                var input = event.currentTarget;
                if (input.files && input.files[0]) {
                    this.form.uploadSubjectScore['subject-score'] = input.files[0];
                }
            },
            isMobile() {
                return 'ontouchstart' in window || navigator.msMaxTouchPoints;
            },
            roleElligibleModified() {
                return this.profile.isAdmin;
            }
        },
        created() {
            this.fetchTryout();
        }
    };
</script>

<style scoped>
    .btn-icon { font-size: 0.8rem; }
    .btn-icon:hover { color: #DA1A31; }
    .btn-icon img { width: 0.6rem; margin-right: 0.2rem; margin-bottom: 0.2rem; }
</style>


// WEBPACK FOOTER //
// src/components/tryout/online/View.vue